// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1EAiV","ant-form-item":"styles_ant-form-item__3IH5Y","title":"styles_title__1wL0g"};